function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './payment-method-form.js';
var CardForm = /*@__PURE__*/proxyCustomElement( /*#__PURE__*/function (_HTMLElement) {
  _inherits(CardForm, _HTMLElement);

  var _super = _createSuper(CardForm);

  function CardForm() {
    var _this;

    _classCallCheck(this, CardForm);

    _this = _super.call(this);

    _this.__registerHost();

    _this.cardFormReady = createEvent(_assertThisInitialized(_this), "cardFormReady", 7);
    _this.ready = createEvent(_assertThisInitialized(_this), "ready", 7);
    _this.cardFormTokenize = createEvent(_assertThisInitialized(_this), "cardFormTokenize", 7);
    _this.cardFormValidate = createEvent(_assertThisInitialized(_this), "cardFormValidate", 7);
    _this.validationMode = undefined;
    _this.iframeOrigin = undefined;
    _this.singleLine = false;
    _this.internalStyleOverrides = undefined;
    return _this;
  }

  _createClass(CardForm, [{
    key: "readyHandler",
    value: function readyHandler(event) {
      console.warn("The 'cardFormReady' event is deprecated in the next major release and will be renamed to 'ready'");
      this.cardFormReady.emit(event);
      this.ready.emit(event);
    }
  }, {
    key: "tokenizeHandler",
    value: function tokenizeHandler(event) {
      console.warn("The 'cardFormTokenize' event is deprecated in the next major release. Please refer to the documentation for the migration process and alternative approach. This method will be removed in the future.");
      this.cardFormTokenize.emit(event);
    }
  }, {
    key: "validateHandler",
    value: function validateHandler(event) {
      console.warn("The 'cardFormValidate' event is deprecated in the next major release. Please refer to the documentation for the migration process and alternative approach. This method will be removed in the future.");
      this.cardFormValidate.emit(event);
    }
    /**
     *  Makes a tokenization request to the iframe
     */

  }, {
    key: "tokenize",
    value: function () {
      var _tokenize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$childRef;

        var _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.childRef) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Cannot call tokenize');

              case 2:
                return _context.abrupt("return", (_this$childRef = this.childRef).tokenize.apply(_this$childRef, _args));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function tokenize() {
        return _tokenize.apply(this, arguments);
      }

      return tokenize;
    }()
    /**
     *  Runs a validation on the form and shows errors if any
     */

  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.childRef) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Cannot call validate');

              case 2:
                return _context2.abrupt("return", this.childRef.validate());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
    /**
     *  Manually resizes the iframe to fit the contents of the iframe
     *  @deprecated This method will be removed in future releases.
     */

  }, {
    key: "resize",
    value: function () {
      var _resize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.warn("The 'resize' method is deprecated and will be removed in the next major release. Please refer to the documentation for the migration process and alternative approach.");

                if (this.childRef) {
                  _context3.next = 3;
                  break;
                }

                throw new Error('Cannot call validate');

              case 3:
                return _context3.abrupt("return", this.childRef.resize());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function resize() {
        return _resize.apply(this, arguments);
      }

      return resize;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return h("justifi-payment-method-form", {
        ref: function ref(el) {
          if (el) {
            _this2.childRef = el;
          }
        },
        "iframe-origin": this.iframeOrigin,
        "payment-method-form-type": "card",
        "single-line": this.singleLine,
        "payment-method-form-ready": this.cardFormReady,
        "payment-method-form-tokenize": this.cardFormTokenize,
        "payment-method-form-validation-mode": this.validationMode || 'onSubmit'
      });
    }
  }]);

  return CardForm;
}(HTMLElement), [0, "justifi-card-form", {
  "validationMode": [1025, "validation-mode"],
  "iframeOrigin": [1025, "iframe-origin"],
  "singleLine": [4, "single-line"],
  "internalStyleOverrides": [32],
  "tokenize": [64],
  "validate": [64],
  "resize": [64]
}, [[0, "paymentMethodFormReady", "readyHandler"], [0, "paymentMethodFormTokenize", "tokenizeHandler"], [0, "paymentMethodFormValidate", "validateHandler"]]]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["justifi-card-form", "justifi-payment-method-form"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "justifi-card-form":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, CardForm);
        }

        break;

      case "justifi-payment-method-form":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }

        break;
    }
  });
}

var JustifiCardForm = CardForm;
var defineCustomElement = defineCustomElement$1;
export { JustifiCardForm, defineCustomElement };